import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface HotelBenchmarkInsightCompetitorsTdDesiredCompetitorInfoSignature {
  Args: {
    value: boolean;
  };
}

export default class HotelBenchmarkInsightCompetitorsTdDesiredCompetitorInfo extends Component<HotelBenchmarkInsightCompetitorsTdDesiredCompetitorInfoSignature> {
  @service declare intl: Services['intl'];

  get icon(): IconName {
    if (this.args.value === true) {
      return 'circle-minus';
    }
    return 'lock';
  }

  get tooltipText(): string {
    if (this.args.value === true) {
      return this.intl.t(
        'settings.competitors.benchmark.compset.desired_competitor_info.data_protection',
      );
    }
    return this.intl.t(
      'settings.competitors.benchmark.compset.desired_competitor_info.no_data',
    );
  }

  <template>
    <div class="flex flex-col items-center justify-center">
      <GeneralIconWithTooltip
        @color="disabled"
        @iconName={{this.icon}}
        @size="small"
        @tooltipContent={{this.tooltipText}}
      />
    </div>
  </template>
}
